// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes Help_appear__XsDVH {
    from {
        opacity: 0;
        transform: translateX(var(--direction));
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.Help_container__X2Nyc {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: #111018;
    color: #fff;
    padding: 32px 32px;
    z-index: 2000;
    /* animation: appear 0.5s ease-out; */
    overflow-y: auto;
}

.Help_closeButton__bu\\+WU {
    position: absolute;
    top: 1%;
    border: none;
    background-color: #ffffff20;
    border-radius: 50%;
    aspect-ratio: 1;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s ease-out;
}

.Help_closeButton__bu\\+WU:hover {
    background-color: #ffffff;
}

.Help_header__pE1Pn {
    margin-top: 8%;
    display: flex;
    gap: 12px;
    align-items: center;
}

.Help_title__S2acp {
    font-size: var(--font-size-12);
    font-family: var(--font-semi-bold), sans-serif;
}

.Help_description__KiEwv {
    font-size: var(--font-size-5);
    line-height: 24px;
    font-family: var(--font-medium), sans-serif;
}

.Help_faq__BTjGB {
    margin-top: 32px;
}

@media (min-width: 768px) and (max-width: 991px) {
    .Help_container__X2Nyc {
        padding: 16px 24px;
        bottom: 9%;
        left: 50%;
        transform: translateX(-50%);
        width: 95%;
        max-width: none;
        border-radius: 16px;
        height: auto;
        top: unset;
    }

    .Help_header__pE1Pn {
        margin-top: 2%;
    }
}

@media (max-width: 767px) {
    .Help_container__X2Nyc {
        right: 0;
        left: 0;
        bottom: 0;
        max-width: 100%;
        padding: 16px 32px;
        margin-top: 7vh;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
    }

    .Help_header__pE1Pn {
        margin-top: 2%;
    }

    .Help_closeButton__bu\\+WU {
        top: 2.5%;
        right: 9%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/Help/Help.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,MAAM;IACN,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,8CAA8C;AAClD;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,eAAe;QACf,mBAAmB;QACnB,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,OAAO;QACP,SAAS;QACT,eAAe;QACf,kBAAkB;QAClB,eAAe;QACf,4BAA4B;QAC5B,6BAA6B;IACjC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,SAAS;IACb;AACJ","sourcesContent":["@keyframes appear {\n    from {\n        opacity: 0;\n        transform: translateX(var(--direction));\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.container {\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: 100%;\n    background-color: #111018;\n    color: #fff;\n    padding: 32px 32px;\n    z-index: 2000;\n    /* animation: appear 0.5s ease-out; */\n    overflow-y: auto;\n}\n\n.closeButton {\n    position: absolute;\n    top: 1%;\n    border: none;\n    background-color: #ffffff20;\n    border-radius: 50%;\n    aspect-ratio: 1;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: background-color 0.3s ease-out;\n}\n\n.closeButton:hover {\n    background-color: #ffffff;\n}\n\n.header {\n    margin-top: 8%;\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n.title {\n    font-size: var(--font-size-12);\n    font-family: var(--font-semi-bold), sans-serif;\n}\n\n.description {\n    font-size: var(--font-size-5);\n    line-height: 24px;\n    font-family: var(--font-medium), sans-serif;\n}\n\n.faq {\n    margin-top: 32px;\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n    .container {\n        padding: 16px 24px;\n        bottom: 9%;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 95%;\n        max-width: none;\n        border-radius: 16px;\n        height: auto;\n        top: unset;\n    }\n\n    .header {\n        margin-top: 2%;\n    }\n}\n\n@media (max-width: 767px) {\n    .container {\n        right: 0;\n        left: 0;\n        bottom: 0;\n        max-width: 100%;\n        padding: 16px 32px;\n        margin-top: 7vh;\n        border-top-left-radius: 16px;\n        border-top-right-radius: 16px;\n    }\n\n    .header {\n        margin-top: 2%;\n    }\n\n    .closeButton {\n        top: 2.5%;\n        right: 9%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Help_container__X2Nyc`,
	"closeButton": `Help_closeButton__bu+WU`,
	"header": `Help_header__pE1Pn`,
	"title": `Help_title__S2acp`,
	"description": `Help_description__KiEwv`,
	"faq": `Help_faq__BTjGB`,
	"appear": `Help_appear__XsDVH`
};
export default ___CSS_LOADER_EXPORT___;
